import BackToTop from './component.jsx'
export default BackToTop
